import { useTranslation } from 'react-i18next';

const BaseModal = ({ id, title=false, children, buttonText, buttonAction }) => {
	const { t } = useTranslation();

	return (
		<div className="modal fade" id={id} tabIndex="-1" role="dialog" aria-hidden="true">
			<div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
				<div className="modal-content position-relative">
					{title ?
						<div className="modal-header">
							<h5 className="modal-title">{title}</h5>
							<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
						</div>
					: ''}
					<div className="modal-body p-0">{children}</div>
					<div className="modal-footer">
						<button className="btn btn-secondary" type="button" data-bs-dismiss="modal">{t('close')}</button>
						{buttonText?
							<button className="btn btn-primary" type="button" data-bs-dismiss="modal" onClick={buttonAction}>{buttonText}</button>
						: ""}
					</div>
				</div>
			</div>
		</div>
	);
};

export default BaseModal;